import CyberWordInvaders from './CyberWordInvaders';

function App() {
  return <CyberWordInvaders />;
}

export default App;
